import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import WhiteLogo from "../../../assets/website/img/mylogo-white.png";
import Hamburger from "./Hamburger";
import { useTranslation } from "react-i18next";
import "./Header.css";
import Button from "@mui/material/Button";
import "./Header.css";

function Header() {
  const location = useLocation(); // Get current location (URL)
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false); // Mobile nav toggle state

  const handleMobileNavToggle = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  useEffect(() => {
    // Close mobile nav when navigating to a different page
    setIsMobileNavOpen(false);
  }, [location]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = "ltr"; // Always force LTR
  }, [i18n.language]); // Runs whenever the language changes

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    // Change body class based on language
    document.body.className =
      i18n.language === "ar" ? "arabic-font" : "english-font";
  }, [i18n.language]);

  return (
    <>
      <header
        id="header"
        className="header d-flex align-items-center fixed-top"
      >
        <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
          <Link to="/" className="logo d-flex align-items-center">
            <Image src={WhiteLogo} />
          </Link>
          <nav
            id="navmenu"
            className={`navmenu ${isMobileNavOpen ? "active" : ""}`}
          >
            <ul>
              <li>
                <Link
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  {t("home")}
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={location.pathname === "/services" ? "active" : ""}
                >
                  {t("services")}
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className={location.pathname === "/portfolio" ? "active" : ""}
                >
                  {t("portfolio")}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  {t("contact")}
                </Link>
              </li>
              <li>
                <Link
                  to="/rate-us"
                  className={location.pathname === "/rate-us" ? "active" : ""}
                >
                  {t("rateUsTitle")}
                </Link>
              </li>
              <li>
                <Button
                  onClick={() => changeLanguage("en")}
                  className="langButton"
                >
                  English
                </Button>
              </li>
              <li>
                <Button
                  onClick={() => changeLanguage("ar")}
                  className="langButton"
                >
                  العربية
                </Button>
              </li>
            </ul>
            <Hamburger />
          </nav>
        </div>
      </header>
    </>
  );
}

export default Header;
